// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"ob_EQf4Tu","searchInput__field":"ob_86vEkc","searchInput__icon":"ob_J5Npmu","searchInput__close_icon":"ob_btz2lX","searchInput__pipe_icon":"ob_c2JVRT"};